import AppNavigations from "./navigation/AppNavigations";

const App = () => {
    return(
        <div className="font-poppins">
            <AppNavigations />
        </div>
    )
}

export default App;